// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deletedialog .el-dialog{width:20.833vw!important}.takecare .el-input{width:11.458vw!important}.listContain4 .tablelistBody .el-table{height:29.948vw!important}.listContain4 .tablelistBody .el-table .el-table__body-wrapper{height:27.656vw!important}", ""]);
// Exports
module.exports = exports;
